import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const rows = [
  { id: 1, name: 'Gold Coin', status: 'Completed' },
  { id: 2, name: 'Silver Bar', status: 'Pending' },
];

const columns = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'name', headerName: 'Item', width: 150 },
  { field: 'status', headerName: 'Status', width: 150 },
];

export default function RedeemOrder() {
  const [pageSize, setPageSize] = React.useState(5);
  const [snackbar, setSnackbar] = React.useState(null);

  return (
    <div style={{ width: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button onClick={() => setSnackbar({ children: 'Refetched!', severity: 'success' })}>
          Refetch rows
        </Button>
        <FormControlLabel
          control={<Checkbox />}
          label="Make the requests fail (disabled)"
        />
      </div>
      <div style={{ height: 400, marginTop: 16 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 25]}
          pagination
        />
        {!!snackbar && (
          <Snackbar
            open
            autoHideDuration={6000}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            onClose={() => setSnackbar(null)}
          >
            <Alert severity={snackbar.severity} onClose={() => setSnackbar(null)}>
              {snackbar.children}
            </Alert>
          </Snackbar>
        )}
      </div>
    </div>
  );
}
